import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { useStyles } from './styles';

function CardHeaderRegular({ srcImg, question }) {
  const classes = useStyles();

  return (
    <Box className={classes.cardHeader}>
      <Box className={classes.imgContainer}>
        <img src={srcImg} alt="" className={classes.img} />
      </Box>
      <Typography className={classes.question}>{question}</Typography>
    </Box>
  );
}

export default CardHeaderRegular;
